import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  hideText?: boolean;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ 
  size = 'md', 
  hideText = false, 
  className = '' 
}) => {
  const sizeClasses = {
    sm: {
      container: 'h-7',
      logo: 'w-7 h-7',
      text: 'text-xs'
    },
    md: {
      container: 'h-10',
      logo: 'w-10 h-10',
      text: 'text-base'
    },
    lg: {
      container: 'h-12',
      logo: 'w-12 h-12',
      text: 'text-lg'
    }
  };

  const sizes = sizeClasses[size];

  return (
    <div className={`flex ${hideText ? 'items-center gap-3' : 'flex-col items-center gap-0'} ${sizes.container} ${className}`}>
      {/* Seamless Logo - Blends with navbar */}
      <div className="relative flex-shrink-0 group flex justify-center">
        <img 
          src="https://res.cloudinary.com/ddf1wv47y/image/upload/v1742485745/Open_Hope_gwfcli.png"
          alt="Open Hope Initiative Nigeria Logo"
          className={`${sizes.logo} object-contain transition-all duration-200 group-hover:opacity-80`}
          style={{ 
            minWidth: sizes.logo.split(' ')[0].replace('w-', '') + 'rem'
          }}
          onError={(e) => {
            console.error('Logo failed to load from Cloudinary');
            // Clean fallback that blends with navbar
            const target = e.currentTarget as HTMLImageElement;
            target.style.display = 'none';
            const container = target.parentElement;
            if (container) {
              container.innerHTML = `
                <div class="${sizes.logo} bg-green-600 rounded-md flex items-center justify-center text-white font-bold text-xs mx-auto">
                  OH
                </div>
              `;
            }
          }}
          onLoad={() => {
            console.log('Logo loaded successfully from Cloudinary');
          }}
        />
      </div>
      
      {/* Text Below Logo - Perfectly Centered */}
      {!hideText && (
        <span 
          className="text-xs leading-none text-gray-600 dark:text-gray-300 font-medium text-center whitespace-nowrap -mt-1"
        >
          Initiative for Nigeria
        </span>
      )}
    </div>
  );
};

export default Logo;
